export default function Hero() {
  return (
    <section id="home" className="relative min-h-screen flex items-center overflow-hidden bg-gradient-to-b from-[#1a2847] via-[#2563eb] to-[#3b82f6]">
      <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-black/10 to-black/20"></div>
      
      <div className="relative w-full px-8 lg:px-16 py-32">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center max-w-7xl mx-auto">
          <div className="space-y-8">
            <div className="inline-block">
              <span className="text-[#06b6d4] text-sm font-bold tracking-[0.15em] uppercase">
                iOS DEVELOPMENT EXPERTS
              </span>
            </div>
            
            <h2 className="text-6xl lg:text-7xl font-bold text-white leading-tight">
              Modern Applications for iOS Platform
            </h2>
            
            <p className="text-2xl text-gray-200 font-light leading-relaxed">
              Enhancing mobile security and user experience
            </p>
          </div>
          
          <div className="flex justify-center lg:justify-end">
            <div className="relative w-80 h-[600px] flex items-center justify-center">
              <div className="absolute inset-0 bg-gradient-to-br from-[#06b6d4]/30 to-[#3b82f6]/30 blur-3xl rounded-full"></div>
              <img
                src="https://public.readdy.ai/ai/img_res/e680fa8c268e433f98a22ff99127ff53.jpg"
                alt="VPN App Interface"
                className="relative z-10 w-full h-full object-contain transform rotate-6 hover:rotate-3 transition-transform duration-500"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}